// features/dependencias/api/dependencias.api.js
import { api } from '../../../api/client';

export const regexApi = {
  /**
   * Obtiene todas las dependencias
   */
  search: () => api.get('/build/regex'),

  /**
   * Crea una nueva dependencia
   * @param {object} data
   */
  create: (data) => {
    // 🔍 DIAGNÓSTICO TEMPORAL — borrar cuando se confirme el origen del bug
    console.log('%c[DEBUG create] data.regex (string real):', 'color:red;font-weight:bold', data.regex);
    console.log('%c[DEBUG create] data.regex.length:', 'color:red;font-weight:bold', data.regex?.length);
    console.log('%c[DEBUG create] JSON que se va a enviar:', 'color:red;font-weight:bold', JSON.stringify(data));
    return api.post('/build/regex', data);
  },

  /**
   * Actualiza una dependencia
   * @param {string|number} id
   * @param {object} data
   */
  update: (id, data) => api.put(`/build/regex/${id}`, data),

  /**
   * Elimina una dependencia
   * @param {string|number} id
   */
  remove: (id) => api.delete(`/build/regex/${id}`),

  /**
   * Valida un regex contra el backend
   * @param {object} data
   */
  validate: (data) => {
    // 🔍 DIAGNÓSTICO TEMPORAL — borrar cuando se confirme el origen del bug
    console.log('%c[DEBUG validate] data.regex (string real):', 'color:red;font-weight:bold', data.regex);
    console.log('%c[DEBUG validate] data.regex.length:', 'color:red;font-weight:bold', data.regex?.length);
    console.log('%c[DEBUG validate] JSON que se va a enviar:', 'color:red;font-weight:bold', JSON.stringify(data));
    return api.post('/build/regex/test', data);
  },

};